import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ckeditor = _resolveComponent("ckeditor");
    const _component_label_form = _resolveComponent("label-form");
    return (_ctx.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("span", { innerHTML: _ctx.value }, null, 8 /* PROPS */, _hoisted_2)
        ]))
        : (_openBlock(), _createBlock(_component_label_form, { key: 1 }, {
            default: _withCtx(() => [
                _createVNode(_component_ckeditor, {
                    editor: _ctx.editor,
                    modelValue: _ctx.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.value) = $event)),
                    config: _ctx.editorConfig
                }, null, 8 /* PROPS */, ["editor", "modelValue", "config"])
            ]),
            _: 1 /* STABLE */
        }));
}
